export default __webpack_public_path__ + "static/media/landing-concept.25b4a899.webp";